import { apiService } from '@/shared/services/apiServices';
import { AxiosError } from 'axios';
import contactRequestEndpoints from './contactRequestEndpoints';
import type {
  CreateContactRequestPayload,
  CreateContactRequestResult,
} from '../types/contactRequestTypes';
import { handleContactRequestError } from '../errors';

export const createContactRequest = async (
  payload: CreateContactRequestPayload
): Promise<CreateContactRequestResult> => {
  try {
    const result = await apiService.postAPI(
      contactRequestEndpoints.CREATE_CONTACT_REQUEST,
      payload
    );

    if (!result.error) {
      const data = result.data as
        | { id?: string; contactRequestId?: string }
        | undefined;
      const contactRequestId = data?.contactRequestId ?? data?.id;
      return {
        success: true,
        ...(contactRequestId ? { contactRequestId } : {}),
      };
    }

    const { errorMessage } = handleContactRequestError(
      result.status,
      result.data,
      result.isNetworkError
    );
    return { success: false, error: errorMessage };
  } catch (error) {
    if (error instanceof AxiosError) {
      const { errorMessage } = handleContactRequestError(
        error.response?.status,
        error.response?.data,
        !error.response && !!error.request
      );
      return { success: false, error: errorMessage };
    }
    return {
      success: false,
      error: 'An unexpected error occurred. Please try again.',
    };
  }
};
